import { Injectable } from '@angular/core'
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, switchMap, tap } from 'rxjs/operators'
import { Router } from '@angular/router'
import { UnoDosHttp } from '@core/https'
import { v4 as uuidv4 } from 'uuid'
import { environment } from '@env/environment'
import { StringHelper } from '@shared/utils'
import { BalanceDto } from '@core/dtos'
import { RoleEnum } from '@core/enums'
import { RoutePathEnum } from '@shared/enums'
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root',
})
export class CheckBalanceInterceptor implements HttpInterceptor {
  private readonly secretKey = environment.unoDosApi.secretKey

  constructor(
    private router: Router,
    private _unoDosHttp: UnoDosHttp,
    private _cookieService: CookieService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('X-Check-Balance')) {
      return next.handle(req)
    }

    if (!this.router.url.startsWith(`/${RoutePathEnum.CARD_GAME}`)) {
      return next.handle(req)
    }

    let accessToken = this._cookieService.get('accessToken')

    if (accessToken?.length > 0) {
      accessToken = sessionStorage.getItem('accessToken') || ''
    }

    
    if (accessToken && accessToken.length === 0) {
      const roleId = parseInt(localStorage.getItem('roleId') || '0')

      if (roleId !== RoleEnum.PLAYER) {
        return next.handle(req)
      }

      const username = localStorage.getItem('username')
      if (!username) {
        console.error('Username not found.')
        this.router.navigate(['/error', 401])
        return throwError(() => new HttpErrorResponse({ status: 401, statusText: 'Unauthorized' }))
      }

      const requestId = uuidv4()
      const sign = this.convertToSign(`${requestId}${username}`)

      return this._unoDosHttp.checkBalance(requestId, username, sign).pipe(
        tap((response: BalanceDto) => {
          if (response.status !== 1) {
            console.error('Balance check failed with status:', response.status)
            this.router.navigate(['/error', 400])
            throw new HttpErrorResponse({
              status: 400,
              statusText: 'Bad Request',
              error: response,
            })
          }
        }),
        switchMap(() => {
          return next.handle(req)
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error occurred:', error)
          if ([401, 404, 500].includes(error.status)) {
            this.router.navigate(['/error', error.status])
          }
          return throwError(() => error)
        }),
      )
    }
    return next.handle(req)
  }

  private convertToSign(str: string): string {
    return StringHelper.convertToMD5(`${str}${this.secretKey}`)
  }
}
